import * as React from "react";
import {
    Popper,
    ClickAwayListener,
    Grow,
    Paper
} from "@material-ui/core";

const ColorChangerPopUp = ({ open, anchorEl, onClose, children }: any) => {
    return (
        <Popper
            open={open}
            anchorEl={anchorEl}
            transition
            disablePortal
            placement="top"
        >
            {({ TransitionProps, placement }) => {
                return (
                    <Grow
                        {...TransitionProps}
                        style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                    >
                        <Paper 
                            style={{
                                marginBottom: "8px",
                                boxShadow: "0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)"
                            }}
                        >
                            <ClickAwayListener onClickAway={onClose}>
                                {children}
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )
            }}
        </Popper>
    )
}

export default ColorChangerPopUp;